import React from 'react';
import { arrayOf, func, object, string } from 'prop-types';
import { Popover } from '@fiverr-private/fit';
import { s_ellipsis } from '@fiverr-private/fit/icons';
import ActionIcon from '../ActionIcon';
import MenuItems from './MenuItems';

const Menu = ({
    menuItems = [],
    onClick = Function.prototype,
    onMenuItemClick = Function.prototype,
    contentClassName,
    boxContentClassName,
}) => (
    <Popover
        className="menu"
        contentClassName={contentClassName}
        boxContentClassName={boxContentClassName}
        content={<MenuItems menuItems={menuItems} onClick={onMenuItemClick} />}
        appendToBody={false}
        position={Popover.POSITIONS.BOTTOM_RIGHT}
    >
        <ActionIcon icon={s_ellipsis} onClick={onClick} />
    </Popover>
);

Menu.propTypes = {
    menuItems: arrayOf(object),
    onClick: func,
    onMenuItemClick: func,
    contentClassName: string,
    boxContentClassName: string,
};

export default Menu;
